import type { PropsWithChildren } from 'react'

export function AppShell({ children }: PropsWithChildren) {
  return <main className="flex min-h-svh flex-col m-0 p-0">{children}</main>
}
